import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import { IconButton, Typography, } from '@mui/material';
import { useNavigate } from "react-router-dom";
import { styled } from '@mui/material/styles';

const CustomListItemText = styled(ListItemText)(({ theme }) => ({
  fontFamily: 'Inter, sans-serif !important',
  fontOpticalSizing: 'auto !important',
  fontWeight: '600 !important',
  fontStyle: 'normal !important',
  fontVariationSettings: '"slnt" 0 !important',
}));

const loadGoogleFont = () => {
  const link = document.createElement('link');
  link.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap';
  link.rel = 'stylesheet';
  document.head.appendChild(link);
};

export default function TemporaryDrawer() {
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    loadGoogleFont(); // Load the font when the component mounts
  }, []);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const buttonStyling = {
    fontFamily: "Inter, sans-serif !important",
    color: 'white',
    borderColor: 'white',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: 'white', 
      color: '#232532',
      borderColor: '#232532', 
    },
  }

  const DrawerList = (
    <Box sx={{ width: 250, bgcolor: '#232532', height: '100vh' }} role="presentation" onClick={toggleDrawer(false)}>
      <List sx={{ width: 250 }}>
        <ListItem key='home' disablePadding>
            <ListItemButton>
              <Button
                variant="outlined"
                sx={buttonStyling}
                onClick={()=>navigate('/')}
              >
                homepage :D
              </Button>

            </ListItemButton>
          </ListItem>
          <ListItem key='about-us' disablePadding>
            <ListItemButton>
              <Button
                variant="outlined"
                sx={buttonStyling}
                onClick={()=>navigate('/about-us')}
              >
                more about us!
              </Button>

            </ListItemButton>
          </ListItem>
          <ListItem key='our-purpose' disablePadding>
            <ListItemButton>
              <Button
                variant="outlined"
                sx={buttonStyling}
                onClick={()=>navigate('/our-purpose')}
              >
                what is our purpose
              </Button>

            </ListItemButton>
          </ListItem>
      </List>
      <Divider />
    </Box>
  );

  return (
    <div>
      <IconButton
        sx={{
          position: 'absolute',
          top: 16,
          right: 16,
          color: 'white',
        }}
        aria-label="menu"
        onClick={toggleDrawer(true)}
      >
        <MenuIcon />
      </IconButton>
      <Drawer open={open} onClose={toggleDrawer(false)}>
        {DrawerList}
      </Drawer>
    </div>
  );
}
